import React, { useEffect, useState } from "react";
import { Card, Row, Col, Form, Input, Button, Checkbox } from "antd";
import "./Prescription.css";
import {
  FireOutlined,
  HeartOutlined,
  BoldOutlined,
  UploadOutlined,
  DownloadOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import ReactDOMServer from "react-dom/server";
import DownloadPrescription from "./DownloadPrescription";
import { API_URL } from "../../config";
import images from "../common/images/images";

const { TextArea } = Input;

const PrescriptionDetails = ({ prescription = {}, onBack }) => {
  const [prescriptions, setPrescriptions] = useState([]);

  useEffect(() => {
    const fetchPrescriptionData = async () => {
      try {
        const response = await fetch(
          `${API_URL}/device/appointment_summary/?appointment_id=${prescription.id}`,
        );
        const data = await response.json();
        setPrescriptions(data);
      } catch (error) {
        console.error("Failed to fetch prescription data:", error);
      }
    };

    fetchPrescriptionData();
  }, [prescription.id]);
  const downloadPDF = () => {
    const prescriptionHtml = ReactDOMServer.renderToString(
      <DownloadPrescription />,
    );

    const tempElement = document.createElement("div");
    tempElement.innerHTML = prescriptionHtml;
    document.body.appendChild(tempElement);

    const pdfWidth = 297;
    const pdfHeight = 420;

    tempElement.style.width = `${pdfWidth * 3}px`;
    tempElement.style.height = `${pdfHeight * 4}px`;

    html2canvas(tempElement, { scale: 4 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "mm", [pdfWidth, pdfHeight]);

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("prescription.pdf");

      document.body.removeChild(tempElement);
    });
  };

  return (
    <div className="prescription-container">
      <Row gutter={16}>
        <Col span={16}>
          <Card title="Patient Info" className="prescription-card">
            <Row gutter={16}>
              <Col span={16}>
                <Row>
                  <Col
                    span={4}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <img
                      src={images.loginUser}
                      alt="Doctor"
                      style={{
                        height: "110px",
                        width: "110px",
                        borderRadius: "50%",
                        objectFit: "cover",
                        alignItems: "center",
                      }}
                    />
                  </Col>
                  <Col span={2}></Col>
                  <Col span={18}>
                    <div className="prescription-details">
                      <p>
                        <strong>{prescription.patient_name}</strong>
                      </p>

                      <p style={{ display: "flex", gap: "20px" }}>
                        <span>Age: 30</span>
                        <span>Gender: Female </span>
                      </p>
                      <p>Contact No: +66-09123232</p>
                      <p>Email: jen.wilson@example.com</p>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col span={8}>
                <Card
                  title="Allergies"
                  bordered={false}
                  style={{ backgroundColor: "#FFE2E2" }}
                >
                  <p>Aspirin</p>
                </Card>
              </Col>
            </Row>
          </Card>
          <Row gutter={16}>
            <Col span={24}>
              <Card title="patient's Note" className="doctor-note">
                <TextArea
                  rows={4}
                  className="doctor-note"
                  placeholder="High fever."
                  disabled
                />
              </Card>
            </Col>
          </Row>
          <Card title="Prescription" className="prescription-details">
            <Row gutter={16}>
              <Col span={8}>
                <Checkbox>Medicine Name</Checkbox>
              </Col>
              <Col span={4}>
                <p>Dosage</p>
              </Col>
              <Col span={4}>
                <p>Frequency</p>
              </Col>
              <Col span={4}>
                <p>Duration</p>
              </Col>
              <Col span={4}>
                <p>Instruction</p>
              </Col>
            </Row>
            <Form>
              <Row gutter={16}>
                <Col span={8}>
                  <Checkbox>Medicine ABC</Checkbox>
                </Col>
                <Col span={4}>
                  <p>500mg</p>
                </Col>
                <Col span={4}>
                  <p>1-0-1</p>
                </Col>
                <Col span={4}>
                  <p>5 days</p>
                </Col>
                <Col span={4}>
                  <p>After meal</p>
                </Col>
              </Row>
            </Form>
          </Card>
          <Row gutter={16}>
            <Col span={24}>
              <Card title="Pharmacist's Note" className="Pharmacist-note">
                <TextArea
                  rows={4}
                  className="Pharmacist-note"
                  placeholder="Pharmacist-note"
                />
              </Card>
            </Col>
          </Row>

          <Row justify="space-between">
            <Col span={8} className="left-align">
              <Button onClick={onBack}>Back Prescription</Button>
            </Col>
            <Col span={8}></Col>
            <Col span={8} className="right-align">
              <Button type="primary" onClick={downloadPDF}>
                Dispense
              </Button>
            </Col>
          </Row>
        </Col>
        <Col span={8} className="prescription-card">
          <Card title="Prescription from" bordered={false}>
            <Row>
              <Col span={6}>
                <img
                  src={images.loginUser}
                  alt="Doctor"
                  style={{
                    height: "70px",
                    width: "70px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
              </Col>
              <Col span={18}>
                <p>Dr Jeremy Tan</p>
                <p>Hospital/Clinic: ABC Hospital</p>
                <p>Registration No: M123-232</p>
                <p>Contact No: +66-12323232</p>
              </Col>
            </Row>
          </Card>
          <Card title="Doctor's Note" className="doctor-note">
            <TextArea
              rows={4}
              className="doctor-note"
              placeholder="High fever. Rest for 3 days"
              disabled
            />
          </Card>
          {prescription.mode !== "TC" && (
            <>
              <Card title="Vital Signs" className="doctor-note">
                <Row gutter={16}>
                  <Col span={12}>
                    <Card className="vital-sign-card">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <p>Blood Pressure</p>
                          <p>
                            {prescriptions
                              .filter(
                                (item) =>
                                  item.device_id === 18 ||
                                  item.device_id === 19,
                              )
                              .map((item) => `${item.value} ${item.units}`)
                              .join(" / ")}
                          </p>
                        </div>
                        <BoldOutlined
                          style={{ fontSize: "24px", color: "#007bff" }}
                        />
                      </div>
                    </Card>
                  </Col>
                  <Col span={12}>
                    <Card className="vital-sign-card">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <p>Heart Rate</p>
                          <p>
                            {prescriptions
                              .filter((item) => item.device_id === 20)
                              .map((item) => `${item.value} ${item.units}`)}
                          </p>
                        </div>
                        <HeartOutlined
                          style={{ fontSize: "24px", color: "#007bff" }}
                        />
                      </div>
                    </Card>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <Card className="vital-sign-card">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <p>Temperature</p>
                          <p>
                            {prescriptions
                              .filter((item) => item.device_id === 17)
                              .map((item) => `${item.value} ${item.units}`)}
                          </p>
                        </div>
                        <FireOutlined
                          style={{ fontSize: "24px", color: "#007bff" }}
                        />
                      </div>
                    </Card>
                  </Col>
                  <Col span={12}>
                    <Card className="vital-sign-card">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <p>SPO2</p>
                          <p>
                            {prescriptions
                              .filter((item) => item.device_id === 20)
                              .map((item) => `${item.value} ${item.units}`)}
                          </p>
                        </div>
                        <SwapOutlined
                          style={{ fontSize: "24px", color: "#007bff" }}
                        />
                      </div>
                    </Card>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <Card className="vital-sign-card">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <p>Height</p>
                          <p>
                            {prescriptions
                              .filter((item) => item.device_id === 1)
                              .map((item) => `${item.value} ${item.units}`)}
                          </p>
                        </div>
                        <UploadOutlined
                          style={{ fontSize: "24px", color: "#007bff" }}
                        />
                      </div>
                    </Card>
                  </Col>
                  <Col span={12}>
                    <Card className="vital-sign-card">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <p>Weight</p>
                          <p>
                            {prescriptions
                              .filter((item) => item.device_id === 2)
                              .map((item) => `${item.value} ${item.units}`)}
                          </p>
                        </div>
                        <DownloadOutlined
                          style={{ fontSize: "24px", color: "#007bff" }}
                        />
                      </div>
                    </Card>
                  </Col>
                </Row>
              </Card>
            </>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PrescriptionDetails;
